export const useKrpanoJs = async () => {
    if (!window.krpanoJS) await import('./krpano-loader');

    return window.krpanoJS;
};
